package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.core.data.getValue
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.navigation.NavParams
import org.moxultimate.topwithmox.productcrud.add.ProductItemAddPage

private data class ProductItemAddData(val contentId: Long)

@InitRoute
fun initProductItemAddRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Add Product"))

    val urlParams: dynamic = js("new URLSearchParams(window.location.search)")
    fun param(key: String): String = (urlParams.get(key) as? String).orEmpty()

    ctx.data.add(ProductItemAddData(
        contentId = param(NavParams.CONTENT_ID).toLongOrNull() ?: 0L,
    ))
}

@Page(routeOverride = "productitemadd")
@Layout(".components.layouts.PageLayout")
@Composable
fun ProductItemAddRoute() {
    val ctx = rememberPageContext()
    val data = ctx.data.getValue<ProductItemAddData>()
    ProductItemAddPage(contentId = data.contentId)
}
